import { node, string, shape } from 'prop-types';
import React from 'react';
import Link from 'components/Link';

function LogoLink({ className, href, logo, gtmAttrs }) {
  return (
    <Link href={href}>
      <a className={className} {...gtmAttrs} aria-label="Site logo">
        {logo}
      </a>
    </Link>
  );
}

LogoLink.propTypes = {
  className: string,
  href: string.isRequired,
  logo: node.isRequired,
  gtmAttrs: shape({
    // data-gtm-*
  })
};

LogoLink.defaultProps = {
  className: undefined,
  gtmAttrs: {}
};

export default LogoLink;
